import React from 'react'
import cx from 'classnames'
import styles from './Heading.module.scss'
import { HeadingProps } from '~types'

const Heading = ({
  children,
  color = 'lightest',
  justify = 'left',
  level,
  levelDisplay,
  noMarginBottom = false,
  noMarginTop = false,
  showHeading = true,
  title = ''
}: HeadingProps) => {
  const resolvedLevel = level ?? '3'

  const classNames = cx(
    styles[`heading`],
    styles[`level-${levelDisplay ? levelDisplay : resolvedLevel}`],
    !showHeading && styles['is-hidden'],
    // Global class names
    `is-color-${color}`,
    `text-justify-${justify}`,
    noMarginBottom && 'mb-0',
    noMarginTop && 'mt-0'
  )

  const HeadingTag = `h${resolvedLevel}` as keyof JSX.IntrinsicElements

  return <HeadingTag className={classNames}>{children ?? title}</HeadingTag>
}

export default Heading
